// API Configuration Utility
// Centralizes all API calls and handles routing to different backends/stored procedures

const isSIP = process.env.REACT_APP_IS_SIP === 'true' || process.env.PUBLIC_URL === '/SIP';
const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://cw-eip.azurewebsites.net';
const apiPrefix = process.env.REACT_APP_API_PREFIX || '';

const config = {
    isSIP: isSIP,
    baseURL: apiBaseUrl,
    apiPrefix: apiPrefix,
    debug: process.env.REACT_APP_DEBUG === 'true',

    // Full API base path
    get apiBasePath() {
        return `${this.baseURL}${this.apiPrefix}`;
    }
};

// API Endpoints
export const API_ENDPOINTS = {
    // Employee endpoints
    employeeLogin: () => `${config.apiBasePath}/Employee/employeeLogin`,
    employeeData: (employeeID) => `${config.apiBasePath}/Employee/${employeeID}`,
    employeeSelection: (programYear, employeeID) =>
        `${config.apiBasePath}/Employee/selection/${programYear}/${employeeID}`,

    // Manager endpoints
    managersEmployees: (programYear, managersEmployeeID) =>
        `${config.apiBasePath}/Manager/employees/${programYear}/${managersEmployeeID}`,
    managerEmployeeSelection: (programYear, managersEmployeeID, employeeID) =>
        `${config.apiBasePath}/Manager/selection/${programYear}/${managersEmployeeID}/${employeeID}`,

    // Order endpoints
    availableItems: (programYear) => `${config.apiBasePath}/Order/items/${programYear}`,
    submitOrder: () => `${config.apiBasePath}/Order/submit`,
    updateOrder: () => `${config.apiBasePath}/Order/update`,
};

// Log configuration in development
if (config.debug) {
    console.log('API Configuration:', {
        isSIP: config.isSIP,
        baseURL: config.baseURL,
        apiPrefix: config.apiPrefix,
        fullPath: config.apiBasePath,
        environment: process.env.NODE_ENV
    });
}

export default config;
